const config = {
    chainId: "0x1",
    contractAddress: "0xef6da0ae231d95cb6097312e13f5fed0ad13bc4c",
    api: "https://okina-labs-claim.azurewebsites.net",
    openSeaCollection: "https://opensea.io/assets/ethereum/0xef6da0ae231d95cb6097312e13f5fed0ad13bc4c/1"
}

export default config;